import icon from 'vue-svgicon';

icon.register({
    'regular/matches-fire': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M10.6 10.143a5.227 5.227 0 0 1 .53 5.957 1.862 1.862 0 0 1-1.986-1.588 4.215 4.215 0 0 0-2.185 3.972 4.766 4.766 0 0 0 4.767 4.766 4.832 4.832 0 0 0 4.766-4.766c.176-4.701-2.554-7.249-5.892-8.341z" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path pid="1" d="M20.617 6.749h-.367l-2.632 3.29a13.344 13.344 0 0 1 .36-9.29A13.4 13.4 0 0 0 6.886 7.727L4.5 5.4a10.5 10.5 0 1 0 16.117 1.349z" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
